import { render, staticRenderFns } from "./ui-modal.vue?vue&type=template&id=0af1f9f2"
import script from "./ui-modal.vue?vue&type=script&lang=js"
export * from "./ui-modal.vue?vue&type=script&lang=js"
import style0 from "./ui-modal.vue?vue&type=style&index=0&id=0af1f9f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports